<template>
    <div>
        <WriteSummaryDialog v-model="showDialog" type='download' :planData='planData' @updateSummary="updateSummary"
                            @close="clickClose()" @cancel="clickCancel()"
                            @confirm="clickConfirm()"></WriteSummaryDialog>
        <CreatePlanDialog v-model="showDialog1" type='download' :planData='planData' @updatePlan="updatePlan"
                          @close="clickClose()" @cancel="clickCancel()"
                          @confirm="clickConfirm()"></CreatePlanDialog>
        <div>
            <div class="viewbox">
                <div class="viewLeft">
                    <i class="fa fa-warning" style="color: red" v-if="plan==null"></i>
                    <i class="fa fa-check-circle" style="color:#00e359" v-if="plan!=null"></i>
                </div>
                <div class="viewRight">
                    <div class="yyheader">
                        <span class="header" style="float: none;">计划任务</span>
                    </div>
                    <div style="margin: 15px 0px 5px 15px;" v-if="plan==null">
                        <span class="f_s15px">暂无计划</span>
                        <a class="writeNote" @click="openCreateDialog(planType, startDate, endDate)">[添加计划]</a>
                    </div>
                    <div style="margin: 15px 0px 5px 15px;" v-if="plan!=null">
                        <router-link target="_blank" :to="{ name: 'planinfo' , params: { id:plan.id} }">
                            {{plan.title}}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="nocontent" v-if="plan!=null && plan.summary">
            <div style="height: 38px;"><i class="fa fa-check-circle" style="color: #00e359"></i> <span
                    class="f_s14px m_l5px f_w6">工作{{planTypeName}}报</span>
            </div>
            <div class="item_question_content" v-if="plan.summary_description.length<=100" title="点击编辑"
                 style="margin-left: 33px;">
                <a @click="openWriteDialog(plan)" style="color: #0a6999" v-html="plan.summary"> </a>
            </div>
            <div class="item_question_content" v-else style="margin-left: 33px;" title="点击编辑">
                <a @click="openWriteDialog(plan)" style="color: #0a628f" v-html="plan.summary.substring(0,100)+'...'">
                </a>
            </div>
        </div>
        <div class="nocontent" v-if="plan==null || !plan.summary">
            <div style="height: 38px;"><i class="fa fa-warning" style="color: red"></i> <span
                    class="f_s14px m_l5px f_w6">工作{{planTypeName}}报</span>
            </div>
            <span class="f_s15px" style="margin-left: 33px;">无{{planTypeName}}报内容</span>
            <a class="writeNote" @click="openWriteDialog(plan)">[填写{{planTypeName}}报]</a>
        </div>
    </div>
</template>

<script type="text/javascript">
    import WriteSummaryDialog from '@/components/common_components/dialog/write_summary_dialog.vue'
    import CreatePlanDialog from '@/apps/plan/sub_components/dialog/create_plan_dialog.vue'
    import {mapState, mapGetters, mapActions} from 'vuex'

    export default {
        props: {
            plan: {
                type: Object,
                require: true,
            },
            planTypeName: {
                type: String,
                require: true,
            },
            planType: {
                type: String,
                require: true,
            },
            startDate: {
                type: String,
                require: true,
            },
            endDate: {
                type: String,
                require: true,
            }
        },
        data: function () {
            return {
                showDialog: false,
                showDialog1: false,
                planData: null,
                show_confirm_dialog: false,
            }
        },
        components: {
            WriteSummaryDialog,
            CreatePlanDialog
        },
        computed: {
            ...mapState({}),
            ...mapGetters({}),
        },
        methods: {
            ...mapActions({}),
            openWriteDialog(plan) {
                if (plan == null) {
                    alert('请先制定计划，才可以填写'+this.planTypeName+'报')
                } else {
                    this.showDialog = true;
                    this.planData = plan;
                }
            },
            openCreateDialog(planType, startDate, endDate) {
                this.showDialog1 = true;
                this.planData = {
                    planType: planType,
                    startDate: startDate,
                    endDate: endDate,
                }
            },
            updateSummary(summary) {
                this.plan.summary = summary
            },
            updatePlan(plan) {
                this.plan = plan
            },
            clickCancel() {
            },
            clickClose() {
                this.showDialog = false;
                this.showDialog1 = false;
            },
            clickConfirm() {
            },
        },
        mounted() {

        }
    }
</script>

<style type="text/css" scoped>
    .nocontent {
        width: 96%;
        line-height: 45px;
        margin-left: 21px;
        margin-bottom: 5px;
    }

    .left {
        margin-top: 15px;
    }

    .item_question_content {
        line-height: 24px;
        margin-top: 11px;
    }

    .item_question_content a:hover {
        text-decoration-line: underline !important;
    }

    .viewbox {
        overflow: hidden;
        margin-bottom: 0;
        margin-top: 10px;
        width: 96%;
        margin-left: 20px;
    }

    .viewbox .viewLeft {
        float: left;
        margin-right: 5px;
        line-height: 26px;
    }

    .viewbox .viewRight {
        float: left;
        font-size: 14px;
        width: 95%;
        line-height: 24px;
    }

    .viewbox .viewRight .yyheader {
        display: inline-block;
        width: 100%;
    }

    .viewbox .viewRight .header {
        float: left;
        font-weight: 700;
        height: 24px;
        line-height: 24px;
        width: 100%;
    }

    .f_w6 {
        font-weight: 600;
    }

    .writeNote {
        margin-left: 10px;
        color: #0a628f;
    }
</style>
